import { FormStore, FormValidator, IJsonSchema } from '@estee/elc-form';
import { action, observable, set } from 'mobx';
import CompanyBillingDetails from '../CompanyBillingDetails';
import Config from '../Config';
import { IAddressSchemaProperties } from '../../../api/JsonSchemaApi';
import { FIELD_TYPE } from '../../../constants/Constants';
import { IAddressAttributes } from '../Address';

class CompanyBillingFormStore extends FormStore<IAddressAttributes> {
  @observable config: Config;

  constructor() {
    super({
      formValidator: new FormValidator(),
      initialValues: {
        [FIELD_TYPE.BILL_TO_COMPANY]: false,
        [FIELD_TYPE.COMPANY_ADDRESS]: '',
        [FIELD_TYPE.COMPANY_NAME]: '',
        [FIELD_TYPE.COMPANY_TAX_NUMBER]: '',
      },
    });
  }

  public getCompanyBillingDetailsValidationSchema(
    validationSchema: IAddressSchemaProperties,
  ): IJsonSchema {
    if (!validationSchema) {
      return null;
    }

    return {
      properties: {
        ...validationSchema,
      },
      required: (Object.keys(validationSchema) as Array<keyof typeof validationSchema>).filter(
        key => validationSchema[key].required,
      ),
    };
  }

  @action
  public setCompanyBillingDetails(
    companyDetails: CompanyBillingDetails,
  ): CompanyBillingFormStore {
    this.setValues(companyDetails.attributes);
    return this;
  }

  public toCompanyBillingDetails(): CompanyBillingDetails {
    const companyBillingDetails = new CompanyBillingDetails();

    set(companyBillingDetails.attributes, this.values);

    return companyBillingDetails;
  }
}

export default CompanyBillingFormStore;
